import React from "react";
import { TILES } from "./crewActivityRules";

/**
 * Activities (clears every filter: all rows), then Fly / Non fly / Change hotel: a click shows only those rows (click
 * again to show all).
 */
export default function CrewActivitySummary({ count, tile, onTile, total, allShown, onAll }) {
  return (
    <section className="hcf-summary dsp-summary" aria-label="Summary">
      <div className="hcf-summary__info">
        <button
          type="button"
          className={`hcf-counter hcf-counter--action dsp-tile${allShown ? " is-selected" : ""}`}
          aria-pressed={allShown}
          title="Show all activities"
          onClick={onAll}
        >
          <i className="fas fa-users" aria-hidden="true" />
          <strong>{total}</strong>
          <span>all activities</span>
          <i className="fas fa-chevron-right hcf-counter__go" aria-hidden="true" />
        </button>
      </div>
      <div className="hcf-summary__actions">
        {TILES.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`hcf-counter hcf-counter--action dsp-tile cra-tile is-${t.id}${tile === t.id ? " is-selected" : ""}`}
            aria-pressed={tile === t.id}
            title={tile === t.id ? "Show all activities" : `Show ${t.label.toLowerCase()} activities`}
            onClick={() => onTile(tile === t.id ? "" : t.id)}
          >
            <i className={t.icon} aria-hidden="true" />
            <strong>{count[t.id]}</strong>
            <span>{t.label.toLowerCase()}</span>
            <i className="fas fa-chevron-right hcf-counter__go" aria-hidden="true" />
          </button>
        ))}
      </div>
    </section>
  );
}
